import React from 'react';
import { motion } from 'framer-motion';
import { AnimatedSection } from './AnimatedSection';
import { BookOpenIcon, ClockIcon, CheckSquareIcon, NotebookPenIcon, LifeBuoyIcon } from 'lucide-react';
const supplementImage = 'https://cdn.magicpatterns.com/uploads/8X3ZS3BSqPfAeFTCTpKqH2/magnesium-glycinate-capsules-magnesio-glicinato-para-salud-diaria-y-mejor-sueno-60-ct_(1).jpg';
const items = [{
  icon: null,
  image: supplementImage,
  title: 'Suplemento Magnesio Glicinato — 60 Cápsulas',
  desc: '250mg por porción. 100% quelado para máxima absorción. Apoya músculo, huesos y corazón.',
  color: '#4ECDC4',
  featured: true
}, {
  icon: BookOpenIcon,
  title: 'Guía Digital "Protocolo Glicinato"',
  desc: 'Todo lo que necesitas saber sobre dosis y tiempos.',
  color: '#4ECDC4'
}, {
  icon: ClockIcon,
  title: 'El Ritual de los 10 Minutos',
  desc: 'El sistema paso a paso para pasar de "alerta máxima" a "paz total".',
  color: '#D4A853'
}, {
  icon: CheckSquareIcon,
  title: 'Checklist: Santuario de Recuperación',
  desc: 'Optimiza tu habitación para una reparación hormonal máxima.',
  color: '#4ECDC4'
}, {
  icon: NotebookPenIcon,
  title: 'Diario de Sueño y Ansiedad',
  desc: 'Identifica tus disparadores de insomnio en tiempo real.',
  color: '#D4A853'
}, {
  icon: LifeBuoyIcon,
  title: 'Bono: La Guía de "Rescate a las 3 AM"',
  desc: 'Por si el insomnio intenta volver.',
  color: '#4ECDC4'
}];
export function WhatYouGet() {
  return <AnimatedSection className="py-16 md:py-24 px-4 sm:px-6" style={{
    background: 'linear-gradient(180deg, #111840 0%, #0D1330 100%)'
  }} data-id="element-156">
      <div className="max-w-5xl mx-auto" data-id="element-157">
        <h2 className="font-display text-2xl md:text-3xl lg:text-4xl font-bold text-white mb-4 text-center" data-id="element-158">
          Lo que <span className="text-[#D4A853]" data-id="element-159">recibes</span>
        </h2>
        <p className="text-gray-400 text-center mb-12 max-w-xl mx-auto" data-id="element-160">
          Un sistema completo para transformar tus noches y tus mañanas.
        </p>

        <div className="space-y-6" data-id="element-161">
          {/* Featured supplement card */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="glass-card rounded-xl p-6 md:p-8 flex flex-col sm:flex-row items-center gap-6" style={{
          borderColor: 'rgba(78, 205, 196, 0.2)'
        }} data-id="element-162">
            <img src={supplementImage} alt="Magnesio Glicinato 60 Cápsulas" className="w-40 h-40 object-cover rounded-xl flex-shrink-0" data-id="element-163" />
            <div data-id="element-164">
              <span className="text-xs uppercase tracking-widest text-[#D4A853] font-semibold mb-2 block" data-id="element-165">
                Incluido en tu paquete
              </span>
              <h3 className="text-white font-semibold text-xl mb-2" data-id="element-166">
                Suplemento Magnesio Glicinato — 60 Cápsulas
              </h3>
              <p className="text-gray-400 leading-relaxed" data-id="element-167">
                250mg por porción. 100% quelado para máxima absorción. Apoya
                músculo, huesos y corazón.
              </p>
            </div>
          </motion.div>

          {/* Other items grid */}
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-168">
            {items.filter(item => !item.featured).map((item, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: i * 0.1
          }} className="glass-card rounded-xl p-6" data-id="element-169">
                  {item.icon && <div className="w-12 h-12 rounded-lg flex items-center justify-center mb-4" style={{
              background: `${item.color}12`,
              border: `1px solid ${item.color}25`
            }} data-id="element-170">
                      <item.icon className="w-6 h-6" style={{
                color: item.color
              }} data-id="element-171" />
                    </div>}
                  <h3 className="text-white font-semibold text-lg mb-2" data-id="element-172">
                    {item.title}
                  </h3>
                  <p className="text-gray-400 text-sm leading-relaxed" data-id="element-173">
                    {item.desc}
                  </p>
                </motion.div>)}

            {/* Motivational card to fill the grid */}
            <motion.div initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.5
          }} className="glass-card rounded-xl p-6 flex flex-col justify-center items-center text-center" style={{
            borderColor: 'rgba(212, 168, 83, 0.2)',
            background: 'linear-gradient(135deg, rgba(212, 168, 83, 0.08), rgba(78, 205, 196, 0.08))'
          }} data-id="element-174">
              <span className="text-3xl mb-3" data-id="element-175">🌙</span>
              <p className="font-display text-lg text-white italic leading-relaxed" data-id="element-176">
                "Dormir bien no es un lujo, es el acto de amor propio más
                poderoso que puedes regalarte cada noche."
              </p>
              <span className="text-[#D4A853] text-sm mt-3 font-medium" data-id="element-177">
                Tu cuerpo se repara mientras duermes
              </span>
            </motion.div>
          </div>
        </div>
      </div>
    </AnimatedSection>;
}